import { getResolvedPath } from '../../../util/routing/entity-paths';

export const ACCOUNTING_INCOME_STATEMENT_BASE_PATH = getResolvedPath('/clearing/finance/accounting/income-statement');
